var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.512c-.13.157-.323.236-.584.236H10.05c-.26 0-.458-.08-.593-.236a.874.874 0 01-.203-.592c0-.237.068-.432.203-.584.135-.15.333-.227.593-.227h1.14v-7.584h-1.14c-.26 0-.458-.08-.593-.235-.135-.156-.203-.354-.203-.592s.068-.433.203-.585c.135-.15.333-.227.593-.227h2.317c.26 0 .455.076.585.227.006.008.01.018.015.025l.006.004c.19.17.287.42.287.748v8.217h1.156c.26 0 .455.075.585.226.133.152.197.347.197.584a.89.89 0 01-.195.592M10.898 4.845c.28-.253.654-.38 1.128-.38.458 0 .83.127 1.117.38.286.254.43.593.43 1.02 0 .424-.14.767-.418 1.028-.28.26-.655.393-1.13.393-.473 0-.848-.132-1.127-.393-.278-.26-.417-.604-.417-1.03 0-.425.14-.764.418-1.018M12 0C5.374 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.63-5.372-12-12-12",
    fill: "#304256",
    fillRule: "evenodd"
  })));
}

export default SvgInfo;